import { esc } from "../ui/format.js";
import { uiGet } from "../ui/kit.js";
import { emRegister } from "./empire.js";

/**
 * 🏛 Your regulators (backend/regulators.py): one shared panel on Risk & Compliance and on
 * Climate & ESG (2026-10-24, Rachit: both answer to regulators). Each watchdog says how it
 * sees you, why, and the one thing that helps, with a button to the tab that does it.
 */

async function regulatorsPanel(host) {
  const v = await uiGet("/regulators");
  host.innerHTML = `<div class="rg-grid">${v.regulators.map((r) => `
    <article class="rg-card ${esc(r.tone)}">
      <div class="rg-top"><span class="rg-ico" aria-hidden="true">${r.icon}</span><b>${esc(r.name)}</b><span class="wf-rv-tag ${r.tone === "good" ? "pos" : r.tone === "bad" ? "neg" : "warn"}">${esc(r.status)}</span></div>
      <p class="rg-read">${esc(r.reading)}</p><p>${esc(r.why)}</p>
      <button type="button" data-rg-go="${esc(r.tab)}">${esc(r.help)} →</button></article>`).join("")}</div>`;
  host.querySelectorAll("[data-rg-go]").forEach((b) => b.addEventListener("click", () => window.ges && window.ges.showTab(b.dataset.rgGo)));
  const bad = v.regulators.some((r) => r.tone === "bad");
  return { title: "Your regulators", summary: v.headline, open: bad, badge: bad ? "!" : "" };
}

emRegister("risk", regulatorsPanel);
emRegister("esg", regulatorsPanel);

export { regulatorsPanel };
